import { Badge } from "@roberttamas/ui";
import { useTranslation } from "react-i18next";

import type { TranslationKey } from "@/i18n";
import type { ZipStatusValue } from "@/lib/types";
import { cn } from "@/lib/utils";

const LABEL_KEYS: Record<ZipStatusValue, TranslationKey> = {
  none: "zipStatus.none",
  refreshing: "zipStatus.refreshing",
  ready: "zipStatus.ready",
  failed: "zipStatus.failed",
};

const STYLES: Record<ZipStatusValue, string> = {
  none: "bg-muted text-muted-foreground",
  refreshing: "bg-blue-500/15 text-blue-600 dark:text-blue-300 animate-pulse",
  ready: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-300",
  failed: "bg-destructive/15 text-destructive",
};

export function StatusBadge({ status }: { status: ZipStatusValue }) {
  const { t } = useTranslation();
  return (
    <Badge variant="outline" className={cn("border-transparent", STYLES[status])}>
      {t(LABEL_KEYS[status])}
    </Badge>
  );
}
